import ConnexPay3ds from '../booking-connexpay-payment/ConnexPay3ds';
import ConnexPayPayment from '../booking-connexpay-payment/ConnexPayPayment';
import { IConnexPayConfiguration } from '../booking-connexpay-payment/ConnexPayService';
import SubmitFatZebra from '../booking-fatzebra-payment/booking-fatzebra-payment';
import MvcValidationService from '../booking-spreedly-payment/MvcValidationService';
import Spreedly3DSLifecycle from '../booking-spreedly-payment/Spreedly3DSLifecycle';
import SpreedlyPayment from '../booking-spreedly-payment/SpreedlyPayment';
import SpreedlyService, { SpreedlyConfiguration } from '../booking-spreedly-payment/SpreedlyService';
import '../validation/ValidatorConfiguration';

export const initFatZebra = (form: JQuery<HTMLFormElement>) => {
    form.on('submit', SubmitFatZebra);
};

export const initSpreedly = (
    spreedlyCardNumber: JQuery,
    spreedlyCvv: JQuery,
    form: JQuery<HTMLFormElement>,
    submitButton: JQuery<HTMLButtonElement>,
    configuration: SpreedlyConfiguration,
) => {
    const spreedlyService = new SpreedlyService(configuration, spreedlyCardNumber, spreedlyCvv);
    const mvcValidationService = new MvcValidationService(form);
    const spreedlyPayment = new SpreedlyPayment(
        form,
        submitButton,
        spreedlyService,
        mvcValidationService
    );
    form.on('submit', event => spreedlyPayment.submitForm(event));
};

export const initConnexPay = (
    form: JQuery<HTMLFormElement>,
    submitButton: JQuery<HTMLButtonElement>,
    configuration: IConnexPayConfiguration) => {

    const connexpayPayment = new ConnexPayPayment(
        form,
        submitButton,
        configuration);
    form.on('submit', event => connexpayPayment.submitForm(event));
}


export default { initFatZebra, initSpreedly, Spreedly3DSLifecycle, initConnexPay, ConnexPay3ds };
